import defaultTheme from "./theme.json";
import configs from "./configs";

export const INVERSE_COLORS =
    defaultTheme.colors.bg.secondary.toLowerCase() === defaultTheme.colors.bg.primary.toLowerCase();

const theme = {
    ...defaultTheme,
    colors: {
        ...defaultTheme.colors,
        focusAccent: defaultTheme.colors.focusAccent || defaultTheme.colors.focus,
        bg: {
            ...defaultTheme.colors.bg,
            surface: INVERSE_COLORS ? defaultTheme.colors.text.primary : defaultTheme.colors.bg.secondary,
            surfaceFocus: INVERSE_COLORS ? defaultTheme.colors.bg.primary : defaultTheme.colors.focus,
            overlay: INVERSE_COLORS ? "#000000" : defaultTheme.colors.bg.primary,
            accent: INVERSE_COLORS ? defaultTheme.colors.text.primary : defaultTheme.colors.bg.light,
            accentFocus: INVERSE_COLORS
                ? defaultTheme.colors.focusAccent || defaultTheme.colors.text.primary
                : defaultTheme.colors.bg.light,
            playbackOverlay: INVERSE_COLORS ? "#000000" : defaultTheme.colors.bg.primary
        },
        text: {
            ...defaultTheme.colors.text,
            surface: INVERSE_COLORS ? defaultTheme.colors.bg.primary : defaultTheme.colors.text.primary,
            surfaceFocus: INVERSE_COLORS ? defaultTheme.colors.bg.primary : defaultTheme.colors.text.primary,
            accentFocus: INVERSE_COLORS ? defaultTheme.colors.bg.primary : defaultTheme.colors.text.accent
        }
    },
    button: {
        ...(defaultTheme.button || {}),
        border: {
            enabled: INVERSE_COLORS,
            color: INVERSE_COLORS ? defaultTheme.colors.text.primary : undefined
        },
        text: {
            color: INVERSE_COLORS ? defaultTheme.colors.bg.light : defaultTheme.colors.text.primary
        }
    },
    layout: {
        ...defaultTheme.layout,
        x: configs.layout.content.alignWithBanner ? defaultTheme.banner.padding.x : defaultTheme.layout.content.x
    }
};

export default theme;
